import MobileCarousel from '../components/MobileCarousel';

export default class BlogPosts {
  constructor(section) {
    this.el = section.el;
    this.carousel = this.el.querySelector('[data-blog-posts-wrapper]');

    this.mobileCarousel = new MobileCarousel({
      carouselWrapper: this.carousel,
      slideSelector: '[data-blog-post]',
    });
  }

  onSectionUnload() {
    this.mobileCarousel.unload();
  }
}
